import { cn } from '@/lib/utils';

import { ArticleObject } from '@/models/Articles';

import UnstyledLink from '../links/UnstyledLink';
import NextImage from '../NextImage';

export default function SimpleArticle(props: ArticleObject) {
  const { title, featuredImage, className, slug = '#', ...rest } = props;

  return (
    <article className={cn(`simple-article relative`, className)} {...rest}>
      <UnstyledLink
        href={slug}
        className='flex w-full items-center gap-4 hover:underline md:gap-8'
      >
        <div className='flex h-32 w-full max-w-36 items-center justify-center overflow-hidden rounded-2xl md:max-w-[182px]'>
          {featuredImage?.node?.sourceUrl ? (
            <NextImage
              src={featuredImage.node.sourceUrl}
              alt={featuredImage?.node?.altText || ''}
              height='128'
              width='182'
              sizes='(max-width: 1200px) 30vw, 145px'
              className='h-full w-full'
              classNames={{ image: 'w-full h-full object-cover' }}
            />
          ) : (
            <div className='pointer-events-none flex h-[128px] w-full items-center justify-center bg-white'>
              <NextImage
                src='/images/knowledge-transfer-gray.svg'
                alt='Knowledge Transfer Acceleration Innovation'
                className='max-w-36 opacity-80'
                width='145'
                height='45'
                sizes='(max-width: 1200px) 30vw, 145px'
              />
            </div>
          )}
        </div>
        <span className='w-full text-lg font-semibold md:text-xl'>{title}</span>
      </UnstyledLink>
    </article>
  );
}
